import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.navbar,
  color: theme.palette.primary.contrastText,
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  maxWidth: 400,
  padding: theme.spacing(2),
  textAlign: 'center',
  '& .logo': {
    marginBottom: theme.spacing(3),
  },
}));

export const Actions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
